<template>
    <div class="row">
        <div class="col-md-12">
            <csp-form-group-select :form="damageForm" :options="descriptionAccidentOptions"
                :override-invalid-feedback="claimTypeComprehensiveInvalidFeedback"
                :override-state="claimTypeComprehensiveState"
                property="descriptionAccident"
                required/>

            <csp-form-group-select v-show="canSelectInsuranceType"
                :form="claimTypeForm" :options="claimTypeOptions"
                property="insuranceType" required/>
        </div>
    </div>
</template>

<script>
    import RecordCreateForm from '@csp-app/lib/damage/record/create/RecordCreateForm';
    import AccidentDescriptionEnum from '@js/enums/damage/AccidentDescriptionEnum';
    import ClaimTypeEnum from '@js/enums/damage/ClaimTypeEnum';
    import ClaimTypeComprehensiveEnum from '@js/enums/damage/ClaimTypeComprehensiveEnum';

    export default {
        props: {
            recordForm: {
                type: RecordCreateForm,
                required: true,
            },
        },
        data() {
            const accidentDescriptionsPartiallyComprehensive = [
                AccidentDescriptionEnum.WILDLIFE_ACCIDENT,
                AccidentDescriptionEnum.MARTEN_DAMAGE,
            ];

            const accidentDescriptionsComprehensive = [
                AccidentDescriptionEnum.GLASS_DAMAGE,
                ...accidentDescriptionsPartiallyComprehensive,
            ];

            const accidentDescriptionsWithoutSelectableClaimType = [
                AccidentDescriptionEnum.NONE,
                ...accidentDescriptionsComprehensive,
            ];

            return {
                accidentDescriptionsComprehensive: accidentDescriptionsComprehensive,
                accidentDescriptionsPartiallyComprehensive: accidentDescriptionsPartiallyComprehensive,
                accidentDescriptionsWithoutSelectableClaimType: accidentDescriptionsWithoutSelectableClaimType,
                claimTypeOptions: [
                    {value: 'casualty', text: 'Nein, ich bin Geschädigter'},
                    {value: 'comprehensive', text: 'Ja, ich bin Unfallverursacher'},
                    {value: 'casualty', text: 'Ich bin mir unsicher'},
                ],
                descriptionAccidentOptions: [
                    {value: AccidentDescriptionEnum.NONE, text: AccidentDescriptionEnum.NONE},
                    {
                        value: AccidentDescriptionEnum.REAR_END_COLLISION,
                        text: AccidentDescriptionEnum.REAR_END_COLLISION,
                    },
                    {value: AccidentDescriptionEnum.PARKING_ACCIDENT, text: AccidentDescriptionEnum.PARKING_ACCIDENT},
                    {
                        value: AccidentDescriptionEnum.WILDLIFE_ACCIDENT,
                        text: AccidentDescriptionEnum.WILDLIFE_ACCIDENT,
                    },
                    {value: AccidentDescriptionEnum.LANE_CHANGE, text: AccidentDescriptionEnum.LANE_CHANGE},
                    {
                        value: AccidentDescriptionEnum.RIGHT_OF_WAY_VIOLATION,
                        text: AccidentDescriptionEnum.RIGHT_OF_WAY_VIOLATION,
                    },
                    {value: AccidentDescriptionEnum.GLASS_DAMAGE, text: AccidentDescriptionEnum.GLASS_DAMAGE},
                    {value: AccidentDescriptionEnum.MARTEN_DAMAGE, text: AccidentDescriptionEnum.MARTEN_DAMAGE},
                    {value: AccidentDescriptionEnum.MISCELLANEOUS, text: AccidentDescriptionEnum.MISCELLANEOUS},
                ],
                recordData: this.recordForm.getData(),
            }
        },
        computed: {
            canSelectInsuranceType() {
                return !this.accidentDescriptionsWithoutSelectableClaimType.includes(
                    this.descriptionAccident
                );
            },
            claimTypeForm() {
                return this.recordForm.getSubform('claimType');
            },
            claimTypeComprehensiveState() {
                return this.claimTypeForm
                    .getValidationState('insuranceComprehensiveType');
            },
            claimTypeComprehensiveInvalidFeedback() {
                return this.claimTypeForm
                    .getInvalidFeedback('insuranceComprehensiveType');
            },
            damageForm() {
                return this.recordForm.getSubform('damage');
            },
            descriptionAccident() {
                return this.damageForm.getDataOfProperty('descriptionAccident');
            },
            isClaimTypeComprehensive() {
                return this.claimTypeForm.getData().insuranceType === ClaimTypeEnum.COMPREHENSIVE;
            },
        },
        watch: {
            'recordData.claimType.data.attributes.insuranceType'() {
                this.updateInsuranceComprehensiveType();
            },
            'recordData.damage.data.attributes.descriptionAccident'() {
                this.updateInsuranceType();
                this.updateInsuranceComprehensiveType();
            },
        },
        methods: {
            updateInsuranceComprehensiveType() {
                if (!this.isClaimTypeComprehensive) {
                    this.claimTypeForm.setProperty('insuranceComprehensiveType', ClaimTypeComprehensiveEnum.FULLY);
                    return;
                }

                if (this.descriptionAccident === '') {
                    this.claimTypeForm.setProperty('insuranceComprehensiveType', '');
                    return;
                }

                if (this.accidentDescriptionsPartiallyComprehensive.includes(this.descriptionAccident)) {
                    this.claimTypeForm.setProperty('insuranceComprehensiveType', ClaimTypeComprehensiveEnum.PARTIALLY);
                    return;
                }

                if (this.descriptionAccident === AccidentDescriptionEnum.GLASS_DAMAGE) {
                    this.claimTypeForm.setProperty(
                        'insuranceComprehensiveType',
                        ClaimTypeComprehensiveEnum.GLASS_DAMAGE
                    );
                    return;
                }

                this.claimTypeForm.setProperty('insuranceComprehensiveType', ClaimTypeComprehensiveEnum.FULLY);
            },
            updateInsuranceType() {
                if (this.isClaimTypeComprehensive) {
                    // no correction necessary
                    return;
                }

                if (this.accidentDescriptionsComprehensive.includes(this.descriptionAccident)) {
                    // switch to comprehensive claim type, as new accident description requires it
                    this.claimTypeForm.setProperty('insuranceType', ClaimTypeEnum.COMPREHENSIVE);
                }
            },
        },
    }
</script>
